import { fetchMoedas } from "@/api/moedas/moedas.js";

const initialState = () => ({
  moedas: null,
});

const state = initialState();

const getters = {};

const actions = {
  getMoedas({ commit }, filtros) {
    if (!state.moedas) {
      return fetchMoedas(filtros)
        .then((response) => {
          commit("UPDATE_MOEDAS", response);
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
    }
  },
  reset({ commit }) {
    commit("RESET");
  },
};

const mutations = {
  RESET(state) {
    const newState = initialState();
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key];
    });
  },
  UPDATE_MOEDAS(state, payload) {
    state.moedas = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
